import { AxisConfig } from "@Layouts/components/Charts/GroupedBarChart/types.ts";

interface CustomXAxisTickProps<T = {}> {
	x?: number;
	y?: number;
	payload?: { value: string; offset: number };
	hoveredValue?: string;
	config?: AxisConfig<T>;
	allXValues?: string[];
	index?: number;
}

export function CustomXAxisTick({ x = 0, y = 0, payload, hoveredValue, config = {}, allXValues = [], index = 0 }: CustomXAxisTickProps) {
	const displayValue = config.labelFormatter ? config.labelFormatter(payload?.value || "") : payload?.value;
	const offset = payload?.offset || 0;

	// Find the index of the hovered value in allXValues
	const hoveredIndex = allXValues.indexOf(hoveredValue || "");

	// Highlight if this is the hovered index OR the previous index
	const isHighlighted = hoveredIndex >= 0 && (index === hoveredIndex || index === hoveredIndex - 1);

	const tickColor = "#2357BE";
	const defaultColor = config.fill || "#666666";
	const color = isHighlighted ? tickColor : defaultColor;
	const fontSize = isHighlighted ? config.fontSize || 14 : config.fontSize || 12;
	const fontWeight = isHighlighted ? "bold" : config.fontWeight || "normal";
	const strokeWidth = isHighlighted ? 2 : 1;

	return (
		<>
			<path d={`M${x + offset},${y}v${-8}`} stroke={color} strokeWidth={strokeWidth} />
			<text
				x={x + offset}
				y={y + 12}
				textAnchor="middle"
				fill={color}
				fontSize={fontSize}
				fontWeight={fontWeight}
				style={{ transition: "all 0.2s ease" }}
			>
				{`${displayValue}`}
			</text>
		</>
	);
}
